import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import replaceCurlyBracketString from '../../server/utils/replaceCurlyBracketString';
import { type TranslatedStringDataFragment } from '../api/fragments/TranslatedStringData';

export type TranslateValueInput = Omit<TranslatedStringDataFragment, '__typename' | 'overrides'> & {
    overrides: Omit<TranslatedStringDataFragment['overrides'][number], '__typename'>[];
};

export type TranslatedString = (value: TranslateValueInput, params?: { [key: string]: string | number }) => string;

const useTranslatedString = () => {
    const { i18n } = useTranslation();

    const { language } = i18n;

    return useCallback<TranslatedString>(
        (value, params) => {
            if (!value) {
                // something is wrong here, not value given at all
                return '';
            }

            if (!value.overrides) {
                // no need to look for an override
                return params ? replaceCurlyBracketString(value.defaultValue, params) : value.defaultValue;
            }

            // look for the override matching the current language
            const match = value.overrides.find(override => override.languagePackId === language);

            // if there's no value, return the default value instead
            const translatedValue = match?.value || value.defaultValue;

            if (!params) {
                return translatedValue;
            }
            // Fill the curly brackets with dynamic params

            return replaceCurlyBracketString(translatedValue, params);
        },
        [language]
    );
};

export default useTranslatedString;
